"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlUtils = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
var UrlUtils;
(function (UrlUtils) {
    function trimLeadingSlash(path) {
        if ((0, isNil_1.default)(path)) {
            return path;
        }
        path = path.startsWith("/") ? path.substr(1) : path;
        return path;
    }
    UrlUtils.trimLeadingSlash = trimLeadingSlash;
    function trimTrailingSlash(path) {
        if ((0, isNil_1.default)(path)) {
            return path;
        }
        path = path.endsWith("/") ? path.substring(0, path.length - 1) : path;
        return path;
    }
    UrlUtils.trimTrailingSlash = trimTrailingSlash;
    function trimLeadingAndTrailingSlash(path) {
        path = trimLeadingSlash(path);
        path = trimTrailingSlash(path);
        return path;
    }
    UrlUtils.trimLeadingAndTrailingSlash = trimLeadingAndTrailingSlash;
    function getSubPathFromUrlPath(path, mainPath) {
        if ((0, isNil_1.default)(path)) {
            throw new Error("path is required to get subpath");
        }
        const trimmedPath = trimLeadingSlash(path);
        const trimmedMainPath = trimLeadingAndTrailingSlash(mainPath);
        const isMainPathInPath = trimmedPath.startsWith(trimmedMainPath);
        if (!isMainPathInPath) {
            return { isMainPathInPath };
        }
        let subPath = trimmedPath.substring(trimmedMainPath.length);
        subPath = trimLeadingSlash(subPath);
        return { isMainPathInPath, subPath };
    }
    UrlUtils.getSubPathFromUrlPath = getSubPathFromUrlPath;
    function matchPathWithMainPath(path, mainPath) {
        if ((0, isNil_1.default)(path)) {
            throw new Error("path is required");
        }
        const trimmedPath = trimLeadingAndTrailingSlash(path);
        const trimmedMainPath = trimLeadingAndTrailingSlash(mainPath);
        const pathValue = trimmedPath.split("/")[0];
        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (pathValue === trimmedMainPath) {
            return true;
        }
        return false;
    }
    UrlUtils.matchPathWithMainPath = matchPathWithMainPath;
    function isUrlWhitelisted(uri, uriWhitelist) {
        return Object.values(uriWhitelist).some((pathRegex) => {
            const regExp = new RegExp(pathRegex);
            const match = uri.match(regExp);
            // eslint-disable-next-line sonarjs/prefer-single-boolean-return
            if ((0, isNil_1.default)(match) || match.length === 0) {
                return false;
            }
            return true;
        });
    }
    UrlUtils.isUrlWhitelisted = isUrlWhitelisted;
    /**
     * Returns the shared domain if the input is a subdomain in the list
     * Returns undefined otherwise
     * e.g. token.life.gov.sg -> life.gov.sg
     */
    function getSharedDomain(inputDomain, sharedDomains) {
        sharedDomains = [].concat(sharedDomains);
        for (const sharedDomain of sharedDomains) {
            if (inputDomain.endsWith(sharedDomain)) {
                return sharedDomain;
            }
        }
        return undefined;
    }
    UrlUtils.getSharedDomain = getSharedDomain;
})(UrlUtils || (exports.UrlUtils = UrlUtils = {}));
//# sourceMappingURL=UrlUtils.js.map